import {createContext} from 'react';

export const BodyHandling = createContext(null);